import loadActionTypes from "./load.types";

export const setLoadsList = (loadsList) => ({
  type: loadActionTypes.SET_LOADS_LIST,
  payload: loadsList,
});

export const setAllLoadsNumber = (allLoadsNo) => ({
  type: loadActionTypes.SET_ALL_LOADS_NUMBER,
  payload: allLoadsNo,
});

export const setCurrentPage = (currentPage) => ({
  type: loadActionTypes.SET_CURRENT_PAGE,
  payload: currentPage,
});

export const setLoadsList_isLoading = (isLoading) => ({
  type: loadActionTypes.SET_LOADS_LIST_IS_LOADING,
  payload: isLoading,
});

export const setReqInfo_isLoading = (isLoading) => ({
  type: loadActionTypes.SET_REQ_INFO_IS_LOADING,
  payload: isLoading,
});

//
export const setCurrentLoad = (load) => ({
  type: loadActionTypes.SET_CURRENT_LOAD,
  payload: load,
});
export const setLoadBits = (bits) => ({
  type: loadActionTypes.SET_LOAD_BITS,
  payload: bits,
});
